import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const BatchControlAdminPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  //   const [modal_list, setmodal_list] = useState(false);
  //   function tog_list() {
  //     setmodal_list(!modal_list);
  //     setEditCompany(null);
  //   }

  //   const [editCompany, setEditCompany] = useState(null);

  //   const [formData, setFormData] = useState({
  //     company_name: "",
  //     selectedImage: null,
  //   });

  //   useEffect(() => {
  //     if (editCompany) {
  //       setFormData({
  //         company_name: editCompany.company_name,
  //         setSelectedImage: null,
  //       });
  //     } else {
  //       setFormData({
  //         company_name: "",
  //         setSelectedImage: null,
  //       });
  //     }
  //   }, [editCompany]);

  //   const [responseMessage, setResponseMessage] = useState("");
  //   const handleInputChange = (e) => {
  //     if (e.target.type === "file") {
  //       setFormData({ ...formData, selectedImage: e.target.files[0] });
  //     } else {
  //       setFormData({ ...formData, [e.target.id]: e.target.value });
  //     }
  //   };
  const authToken = localStorage.getItem("access");
  //  const authToken = JSON.parse(localStorage.getItem("authUser")).token;

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();

  //     try {
  //       const apiUrl = editCompany
  //         ? `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/update/company/${editCompany._id}`
  //         : "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/create/company";

  //       const formDataObject = new FormData();
  //       formDataObject.append("company_name", formData.company_name);
  //       formDataObject.append("company_logo", formData.selectedImage);

  //       const response = await fetch(apiUrl, {
  //         method: editCompany ? "PATCH" : "POST",
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //         body: formDataObject,
  //       });

  //       const responseData = await response.json();

  //       if (response.ok) {
  //         setmodal_list(false);
  //         toast.success(responseData.message);
  //         // setEditCompany(null);
  //         // setEditMode(false);
  //         setFormData({
  //           company_name: "",
  //           setSelectedImage: null,
  //         });
  //         fetchCompany();

  //         // setmodal_list_edit(false);
  //       } else {
  //         toast.error(`Error: ${responseData.error}`);
  //       }
  //     } catch (error) {
  //       console.error("Error submitting form:", error);
  //     }
  //   };

  const [batchData, setBatchData] = useState([]);
  const fetchCompany = async () => {
    try {
      setIsLoading(true)
      // Fetch data from your API
      const response = await fetch(
        "https://api.hanoch.in/users/batch-controls/",
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("batch log", data);
        setBatchData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  const handleDeleteMachine = async (batchId) => {
    try {
      // Make API request to delete the user
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/delete/batch/${batchId}`,
        {
          method: "DELETE",
          // headers: {
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );

      if (response.ok) {
        // If the deletion was successful, refresh the user data
        toast.success("Batch Deleted Successfully");
        fetchCompany();
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error deleting data:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // const filteredCompany = batchData.filter((batch) =>

  //   (batch.machine_name ||"").toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(batchData.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = batchData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Batch Control" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    View, Export & Remove Batch control Data.
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div
                          className="d-flex align-items-center gap-1"
                          style={{ fontSize: "30px", cursor: "pointer" }}
                        >
                          <i className="mdi mdi-microsoft-excel text-success"></i>
                          <span
                            className="text-success"
                            style={{ fontSize: "15px", textAlign: "center" }}
                          >
                            Export Data
                          </span>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="logo">
                              Part Name
                            </th>
                            <th className="sort" data-sort="logo">
                              Operator
                            </th>
                             <th className="sort" data-sort="logo">
                              Date
                            </th>
                             <th className="sort" data-sort="logo">
                              Type
                            </th>
                             <th className="sort" data-sort="logo">
                              Mould tool used
                            </th>
                             <th className="sort" data-sort="logo">
                              Golf label id
                            </th>
                             <th className="sort" data-sort="logo">
                              Supplier lot no
                            </th>
                            <th className="sort" data-sort="logo">
                              Material Used
                            </th>
                            <th className="sort" data-sort="logo">
                              Cavity No
                            </th>
                            <th className="sort" data-sort="logo">
                              Burn Mark
                            </th>
                            <th className="sort" data-sort="logo">
                              Discolouration
                            </th>
                            <th className="sort" data-sort="logo">
                              Spillage
                            </th>
                            <th className="sort" data-sort="logo">
                              Dent Mark
                            </th>
                            <th className="sort" data-sort="logo">
                              Sort Rejections
                            </th>
                            <th className="sort" data-sort="logo">
                              Flash
                            </th>
                            <th className="sort" data-sort="logo">
                              Set Up
                            </th>
                            <th className="sort" data-sort="logo">
                              Short Shots
                            </th>
                            <th className="sort" data-sort="logo">
                              Others
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        {isLoading ? (
                          <div className="text-center">
                            <div className="" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <tbody className="list form-check-all">

                            {currentItems === undefined ? (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : currentItems.length === 0 ? (

                              <tr>
                                <td colSpan="4" className="text-center">
                                  No content found
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((batch, index) => (
                                <tr key={index}>
                                  <td className="customer_name">
                                    {batch.machine_display || "NA"}
                                  </td>
                                  <td>{batch.part || "NA"}</td>
                                   <td>{batch.operator_name || "NA"}</td>
                                  <td>{batch.date || "NA"}</td>
                                  
                                  <td>{batch.type || "NA"}</td>
                                  <td>{batch.mould_tool_used || "NA"}</td>
                                  <td>{batch.golf_label_id || "NA"}</td>
                                  <td>{batch.supplier_lot_no || "NA"}</td>
                                  <td>{batch.material_used || "NA"}</td>
                                  <td>{batch.cavity_number || "NA"}</td>
                                  <td>{batch.burn_mark || "NA"}</td>
                                  <td>{batch.discolouration || "NA"}</td>
                                  <td>{batch.spillage || "NA"}</td>
                                  <td>{batch.dent_mark || "NA"}</td>
                                  <td>{batch.sort_rejections || "NA"}</td>
                                  <td>{batch.flash || "NA"}</td>
                                  <td>{batch.set_up || "NA"}</td>
                                  <td>{batch.short_shots || "NA"}</td>
                                  <td>{batch.others || "NA"}</td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      {/* <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setmodal_list(true);
                                          setEditCompany(machine);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div> */}
                                      <div className="remove">
                                        <button
                                          className="btn btn-danger remove-item-btn"
                                          data-bs-toggle="modal"
                                          data-bs-target="#deleteRecordModal"
                                          onClick={() =>
                                            handleDeleteMachine(batch._id)
                                          }
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        )}
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      {/* <Modal
        isOpen={modal_list}
        toggle={() => {
          // setmodal_list(false);
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_list();
          }}
        >
          {editCompany ? "Edit Company" : "Add Company"}
        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${
              responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
            } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="company_name-field" className="form-label">
                Company Name
              </label>
              <input
                type="text"
                id="company_name"
                className="form-control"
                placeholder="Company Name"
                value={formData.company_name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="company_logo-field" className="form-label">
                Company Logo
              </label>

              <input
                type="file"
                accept="image/*"
                id="company_logo"
                className="form-control"
                placeholder="Company Logo"
                value={formData.company_logo}
                onChange={handleInputChange}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setmodal_list(false);
                  setEditCompany(null);
                }}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editCompany ? "Update Company" : "Add Company"}
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal> */}
    </React.Fragment>
  );
};

export default BatchControlAdminPage;
